import { USER_SERVER, normalizeUserServer } from "./Utility";

export const ADMIN_HOST_SERVER_LIST = Object.freeze({
  localhost: USER_SERVER.LOCAL,
  "127.0.0.1": USER_SERVER.LOCAL,
  "::1": USER_SERVER.LOCAL,
  "flip-app-aps-admin-n7dev.azurewebsites.net": USER_SERVER.DEV,
  "flip-app-aps-admin-stg.azurewebsites.net": USER_SERVER.STG,
  "flip-app-aps-admin-prod.azurewebsites.net": USER_SERVER.PROD,
});

export const normalizeHostname = (value) => `${value || ""}`.trim().toLowerCase();

export const inferUserServerFromHostname = (hostname) =>
  ADMIN_HOST_SERVER_LIST[normalizeHostname(hostname)] || "";

export const resolveUserServer = ({
  configuredServer = "",
  inferredServer = "",
  storedServer = "",
} = {}) => {
  const normalizedConfigured = normalizeUserServer(configuredServer);
  const normalizedInferred = normalizeUserServer(inferredServer);
  const normalizedStored = normalizeUserServer(storedServer);

  if (normalizedConfigured) {
    return normalizedConfigured;
  }

  // Localhost should still honor the user's last explicit target server.
  if (normalizedInferred && normalizedInferred !== USER_SERVER.LOCAL) {
    return normalizedInferred;
  }

  return normalizedStored || normalizedInferred || USER_SERVER.PROD;
};
